import { Box, Typography, makeStyles } from "@material-ui/core";

type Props = {
  background: string;
  title: string;
  value: number;
};

export function StatBox(props: Props) {
  const classes = useStyles();

  return (
    <Box style={{ background: props.background }} className={classes.root}>
      <Box className={classes.titleBox}>
        <Typography variant="h4" display="inline">
          {props.title}
        </Typography>
      </Box>
      <Box className={classes.valueBox}>
        <Typography variant="h1">{props.value}</Typography>
        <Typography variant="h4">st</Typography>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 16,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    border: `1px solid ${theme.palette.divider}`,
    width: "20rem",
    heigth: "8rem",
    borderRadius: theme.shape.borderRadius
  },
  titleBox: {
    height: "4rem",
    display: "flex",
    alignItems: "flex-end",
    paddingBottom: 16
  },
  valueBox: {
    height: "4rem",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "baseline"
  }
}));
